export const legalConfig = {
    companyName: 'AKTE Immobilier',
    legalForm: 'SARL',
    capital: '10 000 €',
    siret: '999 537 087 00010',
    rcs: '999 537 087',
    prefecture: 'CCI ALSACE EUROMETROPLE',
    phone: '07 43 59 54 51',
    email: 'contact@akte-immobilier.com',
    caisse: 'GALIAN SMABTP',
    montant: '120 000€',
    host: {
        name: 'Amazon Web Services Legal Department',
        address: 'P.O. Box 81226 Seattle WA 98108',
        phone: '(206) 266-4064'
    },
    gdpr: {
        responsable: 'Petitcolas Lucie',
        email: 'contact@akte-immobilier.com',
        description: 'Les données personnelles collectées sur ce site sont traitées de manière confidentielle conformément au RGPD.'
    }
};
